module.exports = __webpack_public_path__ + "static/media/shittyMouse.904654ae.jpg";